import { handleActions, createAction } from "redux-actions";
import { axios, axiosWithoutHeaders } from "../cores/axiosWrapper";
import Polling from "../cores/polling";

function patchProjectUserAPI(stageId, apiEndpoint, projectId, userId, body) {
    const headers = {
        stageId,
        projectId,
    };

    return axios.patch(`${apiEndpoint}/projects/${projectId}/members/${userId}`, body, {
        headers,
    });
}

function patchProjectTeamAPI(stageId, apiEndpoint, projectId, teamId, body) {
    const headers = {
        stageId,
        projectId,
    };

    return axios.patch(`${apiEndpoint}/projects/${projectId}/teams/${teamId}`, body, {
        headers,
    });
}

function assignUserAPI(stageId, apiEndpoint, projectId, userId) {
    return axios.post(`${apiEndpoint}/projects/${projectId}/members/${userId}/assign`, "", {
        headers: {
            stageId,
        },
    });
}

function assignTeamAPI(stageId, apiEndpoint, projectId, teamId) {
    return axios.post(`${apiEndpoint}/projects/${projectId}/teams/${teamId}/assign`, "", {
        headers: {
            stageId,
        },
    });
}

function unassignUserAPI(stageId, apiEndpoint, projectId, userId) {
    return axios.post(`${apiEndpoint}/projects/${projectId}/members/${userId}/unassign`, "", {
        headers: {
            stageId,
        },
    });
}

function unassignTeamV2API(stageId, apiEndpoint, projectId, teamId) {
    return axios.delete(`${apiEndpoint}/v3/managements/projects/${projectId}/teams/${teamId}`, "", {
        headers: {
            stageId,
        },
    });
}

function assignUserV2API(stageId, apiEndpoint, projectId, params) {
    return axios.post(`${apiEndpoint}/v3/managements/projects/${projectId}/members`, params, {
        headers: {
            stageId,
        },
    });
}

function assignTeamV2API(stageId, apiEndpoint, projectId, params) {
    return axios.post(`${apiEndpoint}/v3/managements/projects/${projectId}/teams`, params, {
        headers: {
            stageId,
        },
    });
}

function unassignUserV2API(stageId, apiEndpoint, projectId, userId) {
    return axios.delete(`${apiEndpoint}/v3/managements/projects/${projectId}/members/${userId}`, "", {
        headers: {
            stageId,
        },
    });
}

function unassignTeamAPI(stageId, apiEndpoint, projectId, teamId) {
    return axios.post(`${apiEndpoint}/projects/${projectId}/teams/${teamId}/unassign`, "", {
        headers: {
            stageId,
        },
    });
}

function createProjectAPI(stageId, apiEndpoint, params) {
    return axios.post(`${apiEndpoint}/projects`, params, {
        headers: {
            stageId,
        },
    });
}

export function getProjectsAPI(stageId, apiEndpoint, params) {
    const queries = {
        offset: params.offset * params.limit,
        limit: params.limit,
    };

    if (params.keyword) {
        queries[params.keywordType] = params.keyword;
    }

    if (params.scope) {
        queries.scope = params.scope;
    }

    if (params.isIntegratedSearchable) {
        queries.isIntegratedSearchable = params.isIntegratedSearchable;
    }

    if (params.orderField && params.orderKey) {
        queries.orderField = params.orderField;
        queries.orderKey = params.orderKey;
    }

    return axios.get(`${apiEndpoint}/projects`, {
        params: queries,
        headers: {
            stageId,
        },
    });
}

function getProjectAPI(stageId, apiEndpoint, projectId, id) {
    return axios.get(`${apiEndpoint}/projects/${id}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

function getProjectV2API(stageId, apiEndpoint, projectId, id) {
    return axios.get(`${apiEndpoint}/v3/managements/projects/${id}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

function updateProjectAPI(stageId, apiEndpoint, id, data) {
    return axios.patch(`${apiEndpoint}/projects/${id}`, data, {
        headers: {
            stageId,
        },
    });
}

function deleteProjectAPI(stageId, apiEndpoint, id) {
    return axios.delete(`${apiEndpoint}/projects/${id}`, {
        headers: {
            stageId,
        },
    });
}

function getProjectUsersAPI(stageId, apiEndpoint, projectId, id, params, showAll) {
    const queries = {
        offset: params.offset * params.limit,
        limit: params.limit,
    };

    if (params.keyword) {
        queries[params.keywordType] = params.keyword;
    }

    const headers = {
        stageId,
    };

    if (showAll) {
        return axios.get(`${apiEndpoint}/projects/${id}/assignable-members`, {
            params: queries,
            headers,
        });
    } else {
        return axios.get(`${apiEndpoint}/projects/${id}/assigned-members`, {
            params: queries,
            headers,
        });
    }
}

function getProjectUsersV2API(stageId, apiEndpoint, projectId, id, params, showAll) {
    const queries = {
        limit: params.limit,
    };

    if (params.keyword) queries[params.keywordType] = params.keyword;
    if (params.name) queries.name = params.name;
    if (params.nextToken) queries.nextToken = params.nextToken;

    const headers = {
        stageId,
    };

    if (showAll) {
        return axios.get(`${apiEndpoint}/v3/managements/projects/${id}/assignable-members`, {
            params: queries,
            headers,
        });
    } else {
        return axios.get(`${apiEndpoint}/v3/managements/projects/${id}/members`, {
            params: queries,
            headers,
        });
    }
}

function getProjectTeamsV2API(stageId, apiEndpoint, projectId, id, params, showAll) {
    const queries = {
        limit: params.limit,
    };

    if (params.keyword) queries[params.keywordType] = params.keyword;
    if (params.name) queries.name = params.name;
    if (params.nextToken) queries.nextToken = params.nextToken;

    const headers = {
        stageId,
    };

    if (showAll) {
        return axios.get(`${apiEndpoint}/v3/managements/projects/${id}/assignable-teams`, {
            params: queries,
            headers,
        });
    } else {
        return axios.get(`${apiEndpoint}/v3/managements/projects/${id}/teams`, {
            params: queries,
            headers,
        });
    }
}

function getProjectTeamsAPI(stageId, apiEndpoint, projectId, id, params, showAll) {
    const queries = {
        limit: params.limit,
    };

    if (params.keyword) queries[params.keywordType] = params.keyword;
    if (params.nextToken) queries.nextToken = params.nextToken;

    const headers = {
        stageId,
    };
    if (projectId) headers.projectId = projectId;

    if (showAll) {
        return axios.get(`${apiEndpoint}/projects/${id}/assignable-teams`, {
            params: queries,
            headers,
        });
    } else {
        return axios.get(`${apiEndpoint}/projects/${id}/assigned-teams`, {
            params: queries,
            headers,
        });
    }
}

function getProjectStatusAPI(stageId, apiEndpoint, projectId) {
    return axios.get(`${apiEndpoint}/projects/${projectId}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

function getSupportedRegionsAPI(stageId, apiEndpoint, params) {
    return axios.get(`${apiEndpoint}/supported-regions/aws`, {
        headers: {
            stageId,
        },
        params,
    });
}

const PROJECT_MANAGEMENT_PENDING = "PROJECT_MANAGEMENT_PENDING";
const PROJECT_MANAGEMENT_FAILURE = "PROJECT_MANAGEMENT_FAILURE";
const PROJECT_MANAGEMENT_UPDATE_PARAMS = "PROJECT_MANAGEMENT_UPDATE_PARAMS";
const PROJECT_MANAGEMENT_RESET_PARAMS = "PROJECT_MANAGEMENT_RESET_PARAMS";
const PROJECT_MANAGEMENT_GET_PROJECTS_SUCCESS = "PROJECT_MANAGEMENT_GET_PROJECTS_SUCCESS";
const PROJECT_MANAGEMENT_GET_PROJECT_SUCCESS = "PROJECT_MANAGEMENT_GET_PROJECT_SUCCESS";
const PROJECT_MANAGEMENT_CREATE_PROJECT_SUCCESS = "PROJECT_MANAGEMENT_CREATE_PROJECT_SUCCESS";
const PROJECT_MANAGEMENT_UPDATE_PROJECT_SUCCESS = "PROJECT_MANAGEMENT_UPDATE_PROJECT_SUCCESS";

const PROJECT_MANAGEMENT_PROJECT_USERS_PENDING = "PROJECT_MANAGEMENT_PROJECT_USERS_PENDING";
const PROJECT_MANAGEMENT_GET_PROJECT_USERS_SUCCESS = "PROJECT_MANAGEMENT_GET_PROJECT_USERS_SUCCESS";
const PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE = "PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE";

const PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING = "PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING";
const PROJECT_MANAGEMENT_GET_PROJECT_TEAMS_SUCCESS = "PROJECT_MANAGEMENT_GET_PROJECT_TEAMS_SUCCESS";
const PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE = "PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE";

const PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_PENDING = "PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_PENDING";
const PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_TEAMS_SUCCESS =
    "PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_TEAMS_SUCCESS";
const PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_FAILURE = "PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_FAILURE";
const PROJECT_MANAGEMENT_UPDATE_PROJECT_TEAMS_PARAMS = "PROJECT_MANAGEMENT_UPDATE_PROJECT_TEAMS_PARAMS";
const PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_TEAMS_PARAMS =
    "PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_TEAMS_PARAMS";

const PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_PENDING = "PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_PENDING";
const PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_USERS_SUCCESS =
    "PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_USERS_SUCCESS";
const PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_FAILURE = "PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_FAILURE";
const PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_USERS_PARAMS =
    "PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_USERS_PARAMS";

const PROJECT_MANAGEMENT_UPDATE_PROJECT_USERS_PARAMS = "PROJECT_MANAGEMENT_UPDATE_PROJECT_USERS_PARAMS";
const PROJECT_MANAGEMENT_DELETE_PROJECT_SUCCESS = "PROJECT_MANAGEMENT_DELETE_PROJECT_SUCCESS";
const PROJECT_MANAGEMENT_CLOSE_PROJECTS_ACTIONS = "PROJECT_MANAGEMENT_CLOSE_PROJECTS_ACTIONS";
const PROJECT_MANAGEMENT_TOGGLE_PROJECTS_ACTIONS = "PROJECT_MANAGEMENT_TOGGLE_PROJECTS_ACTIONS";

const PROJECT_MANAGEMENT_RESET_USERS_PARAMS = "PROJECT_MANAGEMENT_RESET_USERS_PARAMS";
const PROJECT_MANAGEMENT_RESET_TEAMS_PARAMS = "PROJECT_MANAGEMENT_RESET_TEAMS_PARAMS";
const PROJECT_MANAGEMENT_ASSIGN_USER_SUCCESS = "PROJECT_MANAGEMENT_ASSIGN_USER_SUCCESS";
const PROJECT_MANAGEMENT_ASSIGN_USER_V2_SUCCESS = "PROJECT_MANAGEMENT_ASSIGN_USER_V2_SUCCESS";
const PROJECT_MANAGEMENT_ASSIGN_TEAM_SUCCESS = "PROJECT_MANAGEMENT_ASSIGN_TEAM_SUCCESS";
const PROJECT_MANAGEMENT_ASSIGN_TEAM_V2_SUCCESS = "PROJECT_MANAGEMENT_ASSIGN_TEAM_V2_SUCCESS";
const PROJECT_MANAGEMENT_UNASSIGN_USER_SUCCESS = "PROJECT_MANAGEMENT_UNASSIGN_USER_SUCCESS";
const PROJECT_MANAGEMENT_UNASSIGN_TEAM_SUCCESS = "PROJECT_MANAGEMENT_UNASSIGN_TEAM_SUCCESS";

const PROJECT_MANAGEMENT_UPDATE_USER_SUCCESS = "PROJECT_MANAGEMENT_UPDATE_USER_SUCCESS";
const PROJECT_MANAGEMENT_UPDATE_TEAM_SUCCESS = "PROJECT_MANAGEMENT_UPDATE_TEAM_SUCCESS";

const PROJECT_MANAGEMENT_UPDATE_PROJECT_STATUS = "PROJECT_MANAGEMENT_UPDATE_PROJECT_STATUS";
const PROJECT_MANAGEMENT_RESET_PROJECT = "PROJECT_MANAGEMENT_RESET_PROJECT";
const PROJECT_MANAGEMENT_INIT_PROJECT = "PROJECT_MANAGEMENT_INIT_PROJECT";
const PROJECT_MANAGEMENT_GET_ALL_PROJECTS_SUCCESS = "PROJECT_MANAGEMENT_GET_ALL_PROJECTS_SUCCESS";
const PROJECT_MANAGEMENT_GET_ALL_PROJECTS_FAILURE = "PROJECT_MANAGEMENT_GET_ALL_PROJECTS_FAILURE";

const PROJECT_MANAGEMENT_SUPPORTED_REGIONS_PENDING = "PROJECT_MANAGEMENT_SUPPORTED_REGIONS_PENDING";
const PROJECT_MANAGEMENT_SUPPORTED_REGIONS_SUCCESS = "PROJECT_MANAGEMENT_SUPPORTED_REGIONS_SUCCESS";
const PROJECT_MANAGEMENT_SUPPORTED_REGIONS_FAILURE = "PROJECT_MANAGEMENT_SUPPORTED_REGIONS_FAILURE";

const PROJECT_MANAGEMENT_RESET_ASSIGNABLE_TEAMS_PARAMS = "PROJECT_MANAGEMENT_RESET_ASSIGNABLE_TEAMS_PARAMS";
const PROJECT_MANAGEMENT_RESET_ASSIGNABLE_USERS_PARAMS = "PROJECT_MANAGEMENT_RESET_ASSIGNABLE_USERS_PARAMS";

const initialState = {
    pending: false,
    error: false,
    params: {
        keywordType: "name",
        keyword: "",
        offset: 0,
        limit: 50,
        orderField: "CreatedAt",
        orderKey: "DESC",
    },
    totalCount: 0,
    projects: [],
    project: null,
    userTotalCount: 0,
    teamTotalCount: 0,
    allProjects: [],
    users: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "username",
            keyword: "",
            offset: 0,
            limit: 50,
            tokenPaginationInfo: [],
        },
    },
    teams: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            keyword: "",
            offset: 0,
            limit: 50,
            tokenPaginationInfo: [],
        },
    },
    assignableTeams: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            offset: 0,
            limit: 20,
        },
    },
    assignableUsers: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "username",
            offset: 0,
            limit: 20,
        },
    },
    isCreateProjectSuccess: false,
    isCreateProjectComplete: false,
    isPolling: false,
    hasReset: false,
    supportedRegions: {
        pending: false,
        data: null,
        error: false,
    },
};

export default handleActions(
    {
        [PROJECT_MANAGEMENT_PENDING]: (state) => {
            return {
                ...state,
                pending: true,
                error: false,
                projects: [],
            };
        },
        [PROJECT_MANAGEMENT_FAILURE]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: true,
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECTS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            return {
                ...state,
                pending: false,
                error: false,
                totalCount: data.totalCount,
                projects: data.results,
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PARAMS]: (state, action) => {
            return {
                ...state,
                params: {
                    ...state.params,
                    ...action.payload,
                },
            };
        },
        [PROJECT_MANAGEMENT_RESET_PARAMS]: (state) => {
            return {
                ...state,
                params: {
                    ...state.params,
                    keyword: "",
                    offset: 0,
                    limit: 50,
                },
            };
        },
        [PROJECT_MANAGEMENT_RESET_USERS_PARAMS]: (state) => {
            return {
                ...state,
                users: {
                    ...state.users,
                    params: {
                        ...initialState.users.params,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_RESET_TEAMS_PARAMS]: (state) => {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    params: {
                        ...initialState.teams.params,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_RESET_ASSIGNABLE_TEAMS_PARAMS]: (state) => {
            return {
                ...state,
                assignableTeams: {
                    ...initialState.assignableTeams,
                },
            };
        },
        [PROJECT_MANAGEMENT_RESET_ASSIGNABLE_USERS_PARAMS]: (state) => {
            return {
                ...state,
                assignableUsers: {
                    ...initialState.assignableUsers,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECT_SUCCESS]: (state, action) => {
            const { data } = action.payload;

            return {
                ...state,
                pending: false,
                error: false,
                project: data,
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PROJECT_SUCCESS]: (state, action) => {
            const { data } = action.payload;

            return {
                ...state,
                pending: false,
                error: false,
                project: data,
            };
        },
        [PROJECT_MANAGEMENT_CREATE_PROJECT_SUCCESS]: (state, action) => {
            const { data } = action.payload;

            return {
                ...state,
                pending: false,
                error: false,
                errorStatus: null,
                isCreateProjectSuccess: true,
                projectId: data.id,
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_USERS_PENDING]: (state) => {
            return {
                ...state,
                users: {
                    ...state.users,
                    results: [],
                    pending: true,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECT_USERS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            const newTokenPaginationInfo = [...state.users.params?.tokenPaginationInfo];
            newTokenPaginationInfo[state.users.params.offset] = data.nextToken;

            return {
                ...state,
                users: {
                    ...state.users,
                    totalCount: data.totalCount,
                    results: data.results,
                    pending: false,
                    error: false,
                    params: {
                        ...state.users.params,
                        tokenPaginationInfo: newTokenPaginationInfo,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE]: (state) => {
            return {
                ...state,
                users: {
                    ...state.users,
                    pending: false,
                    error: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING]: (state) => {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    results: [],
                    pending: true,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECT_TEAMS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            const newTokenPaginationInfo = [...state.teams.params?.tokenPaginationInfo];
            newTokenPaginationInfo[state.teams.params.offset] = data.nextToken;

            return {
                ...state,
                teams: {
                    ...state.teams,
                    totalCount: data.totalCount,
                    results: data.results,
                    nextToken: data.nextToken,
                    pending: false,
                    error: false,
                    params: {
                        ...state.teams.params,
                        tokenPaginationInfo: newTokenPaginationInfo,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE]: (state) => {
            return {
                ...state,
                teams: {
                    ...state.teams,
                    pending: false,
                    error: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_PENDING]: (state, action) => {
            return {
                ...state,
                assignableTeams: {
                    ...state.assignableTeams,
                    ...(action.payload.isInit ? { results: [] } : {}),
                    pending: true,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_TEAMS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            return {
                ...state,
                assignableTeams: {
                    ...state.assignableTeams,
                    totalCount: data.totalCount,
                    results: data.results,
                    nextToken: data.nextToken ?? null,
                    pending: false,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_FAILURE]: (state) => {
            return {
                ...state,
                assignableTeams: {
                    ...state.assignableTeams,
                    pending: false,
                    error: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_PENDING]: (state, action) => {
            return {
                ...state,
                assignableUsers: {
                    ...state.assignableUsers,
                    ...(action.payload.isInit ? { results: [] } : {}),
                    pending: true,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_USERS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            return {
                ...state,
                assignableUsers: {
                    ...state.assignableUsers,
                    totalCount: data.totalCount,
                    results: data.results,
                    nextToken: data.nextToken ?? null,
                    pending: false,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_FAILURE]: (state) => {
            return {
                ...state,
                assignableUsers: {
                    ...state.assignableUsers,
                    pending: false,
                    error: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PROJECT_TEAMS_PARAMS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                teams: {
                    ...state.teams,
                    params: {
                        ...state.teams.params,
                        ...action.payload,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PROJECT_USERS_PARAMS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                users: {
                    ...state.users,
                    params: {
                        ...state.users.params,
                        ...action.payload,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_DELETE_PROJECT_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
            };
        },
        [PROJECT_MANAGEMENT_TOGGLE_PROJECTS_ACTIONS]: (state, action) => {
            return {
                ...state,
                projects: state.projects.map((v) => {
                    return {
                        ...v,
                        isOpen: v.id === action.payload ? !v.isOpen : false,
                    };
                }),
            };
        },
        [PROJECT_MANAGEMENT_CLOSE_PROJECTS_ACTIONS]: (state) => {
            return {
                ...state,
                projects: state.projects.map((v) => {
                    return {
                        ...v,
                        isOpen: false,
                    };
                }),
            };
        },
        [PROJECT_MANAGEMENT_ASSIGN_USER_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                users: {
                    ...state.users,
                    results: state.users.results.map((v) => {
                        return {
                            ...v,
                            belongToProject: v.id === action.payload ? true : v.belongToProject,
                        };
                    }),
                },
            };
        },
        [PROJECT_MANAGEMENT_ASSIGN_USER_V2_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
            };
        },
        [PROJECT_MANAGEMENT_ASSIGN_TEAM_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                teams: {
                    ...state.teams,
                    results: state.teams.results.map((v) => {
                        return {
                            ...v,
                            belongToProject: v.id === action.payload ? true : v.belongToProject,
                        };
                    }),
                },
            };
        },
        [PROJECT_MANAGEMENT_ASSIGN_TEAM_V2_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
            };
        },
        [PROJECT_MANAGEMENT_UNASSIGN_USER_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                users: {
                    ...state.users,
                    results: state.users.results.map((v) => {
                        return {
                            ...v,
                            belongToProject: v.id === action.payload ? false : v.belongToProject,
                        };
                    }),
                },
            };
        },
        [PROJECT_MANAGEMENT_UNASSIGN_TEAM_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                teams: {
                    ...state.teams,
                    results: state.teams.results.map((v) => {
                        return {
                            ...v,
                            belongToProject: v.id === action.payload ? false : v.belongToProject,
                        };
                    }),
                },
            };
        },

        [PROJECT_MANAGEMENT_UPDATE_PROJECT_STATUS]: (state, action) => {
            const { data } = action.payload;
            if (data.status && data.status !== "") {
                return {
                    ...state,
                    project: {
                        ...state.project,
                        status: data.status,
                    },
                    isCreateProjectComplete: data.status === "COMPLETE",
                };
            } else
                return {
                    ...state,
                };
        },
        [PROJECT_MANAGEMENT_RESET_PROJECT]: (state, action) => {
            return {
                ...initialState,
                hasReset: true,
            };
        },
        [PROJECT_MANAGEMENT_INIT_PROJECT]: (state, action) => {
            return {
                ...initialState,
            };
        },

        [PROJECT_MANAGEMENT_UPDATE_USER_SUCCESS]: (state, action) => {
            const payload = action.payload;
            return {
                ...state,
                users: {
                    ...state.users,
                    results: (state.users.results || []).map((v) => {
                        if (v.id === payload.id) {
                            return {
                                ...v,
                                ...payload,
                            };
                        }
                        return v;
                    }),
                    pending: false,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_TEAM_SUCCESS]: (state, action) => {
            const payload = action.payload;
            return {
                ...state,
                teams: {
                    ...state.teams,
                    results: (state.teams.results || []).map((v) => {
                        if (v.id === payload.id) {
                            return {
                                ...v,
                                ...payload,
                            };
                        }
                        return v;
                    }),
                    pending: false,
                    error: false,
                },
            };
        },
        [PROJECT_MANAGEMENT_GET_ALL_PROJECTS_SUCCESS]: (state, action) => {
            const payload = action.payload;
            return {
                ...state,
                pending: false,
                error: false,
                allProjects: payload.results,
            };
        },
        [PROJECT_MANAGEMENT_GET_ALL_PROJECTS_FAILURE]: (state, action) => {
            const payload = action.payload;
            return {
                ...state,
                pending: false,
                error: true,
                allProjects: [],
            };
        },
        [PROJECT_MANAGEMENT_SUPPORTED_REGIONS_PENDING]: (state, action) => {
            return {
                ...state,
                supportedRegions: {
                    ...state.supportedRegions,
                    pending: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_SUPPORTED_REGIONS_SUCCESS]: (state, action) => {
            return {
                ...state,
                supportedRegions: {
                    ...state.supportedRegions,
                    pending: false,
                    data: action.payload.data,
                },
            };
        },
        [PROJECT_MANAGEMENT_SUPPORTED_REGIONS_FAILURE]: (state, action) => {
            return {
                ...state,
                supportedRegions: {
                    ...state.supportedRegions,
                    pending: false,
                    error: true,
                },
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_TEAMS_PARAMS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                assignableTeams: {
                    ...state.assignableTeams,
                    params: {
                        ...state.assignableTeams.params,
                        ...action.payload,
                    },
                },
            };
        },
        [PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_USERS_PARAMS]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: false,
                assignableUsers: {
                    ...state.assignableUsers,
                    params: {
                        ...state.assignableUsers.params,
                        ...action.payload,
                    },
                },
            };
        },
    },
    initialState,
);

function startPolling(projectId, dispatch, getState) {
    const { stage } = getState();

    Polling(
        async () => {
            return await getProjectStatusAPI(stage.id, stage.endpoint, projectId);
        },
        (response) => {
            if (getState().projectManagement.hasReset) return true;

            if (response.data.status === "COMPLETE" || response.data.status === "ERROR") return true;
        },
        (response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UPDATE_PROJECT_STATUS,
                payload: response,
            });
        },
        null,
        3000,
    ).run();
}

export const closeActions = createAction(PROJECT_MANAGEMENT_CLOSE_PROJECTS_ACTIONS);
export const toggleActions = createAction(PROJECT_MANAGEMENT_TOGGLE_PROJECTS_ACTIONS);
export const updateTeamParams = createAction(PROJECT_MANAGEMENT_UPDATE_PROJECT_TEAMS_PARAMS);
export const updateAssignableTeamParams = createAction(PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_TEAMS_PARAMS);
export const updateAssignableUserParams = createAction(PROJECT_MANAGEMENT_UPDATE_PROJECT_ASSIGNABLE_USERS_PARAMS);
export const updateUserParams = createAction(PROJECT_MANAGEMENT_UPDATE_PROJECT_USERS_PARAMS);
export const resetParams = createAction(PROJECT_MANAGEMENT_RESET_PARAMS);
export const resetUserParams = createAction(PROJECT_MANAGEMENT_RESET_USERS_PARAMS);
export const resetTeamParams = createAction(PROJECT_MANAGEMENT_RESET_TEAMS_PARAMS);
export const resetAssignableTeamParams = createAction(PROJECT_MANAGEMENT_RESET_ASSIGNABLE_TEAMS_PARAMS);
export const resetAssignableUserParams = createAction(PROJECT_MANAGEMENT_RESET_ASSIGNABLE_USERS_PARAMS);
export const reset = createAction(PROJECT_MANAGEMENT_RESET_PROJECT);
export const initialize = createAction(PROJECT_MANAGEMENT_INIT_PROJECT);
export const updateParams = createAction(PROJECT_MANAGEMENT_UPDATE_PARAMS);
export const assignUser = (projectId, userId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });
    return assignUserAPI(stage.id, stage.endpoint, projectId, userId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_ASSIGN_USER_SUCCESS,
                payload: userId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const assignUserV2 = (projectId, params) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });
    return assignUserV2API(stage.id, stage.endpoint, projectId, params)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_ASSIGN_USER_V2_SUCCESS,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const assignMultiUsersV2 = (projectId, data) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    const response = await Promise.allSettled(
        data.map(async (params) => {
            await assignUserV2API(stage.id, stage.endpoint, projectId, params);
        }),
    );

    const errorResponse = response.find((el) => el.status === "rejected");
    if (errorResponse) {
        dispatch({
            type: PROJECT_MANAGEMENT_FAILURE,
            payload: errorResponse,
        });
        throw errorResponse.reason;
    }

    dispatch({
        type: PROJECT_MANAGEMENT_ASSIGN_USER_V2_SUCCESS,
    });
    return response;
};

export const assignTeam = (projectId, teamId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return assignTeamAPI(stage.id, stage.endpoint, projectId, teamId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_ASSIGN_TEAM_SUCCESS,
                payload: teamId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const assignTeamV2 = (projectId, params) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return assignTeamV2API(stage.id, stage.endpoint, projectId, params)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_ASSIGN_TEAM_V2_SUCCESS,
                payload: params.teamId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const assignMultiTeamsV2 = (projectId, data) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    const response = await Promise.allSettled(
        data.map(async (params) => {
            await assignTeamV2API(stage.id, stage.endpoint, projectId, params);
        }),
    );

    const errorResponse = response.find((el) => el.status === "rejected");
    if (errorResponse) {
        dispatch({
            type: PROJECT_MANAGEMENT_FAILURE,
            payload: errorResponse,
        });
        throw errorResponse.reason;
    }

    dispatch({
        type: PROJECT_MANAGEMENT_ASSIGN_TEAM_V2_SUCCESS,
    });
    return response;
};

export const unassignUser = (projectId, userId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return unassignUserAPI(stage.id, stage.endpoint, projectId, userId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UNASSIGN_USER_SUCCESS,
                payload: userId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const unassignUserV2 = (projectId, userId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return unassignUserV2API(stage.id, stage.endpoint, projectId, userId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UNASSIGN_USER_SUCCESS,
                payload: userId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};
export const unassignTeam = (projectId, teamId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return unassignTeamAPI(stage.id, stage.endpoint, projectId, teamId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UNASSIGN_TEAM_SUCCESS,
                payload: teamId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const unassignTeamV2 = (projectId, teamId) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return unassignTeamV2API(stage.id, stage.endpoint, projectId, teamId)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UNASSIGN_TEAM_SUCCESS,
                payload: teamId,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const createProject =
    (params, callback = (project) => {}) =>
    (dispatch, getState) => {
        const { stage } = getState();

        dispatch({ type: PROJECT_MANAGEMENT_PENDING });
        return createProjectAPI(stage.id, stage.endpoint, params)
            .then((response) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_CREATE_PROJECT_SUCCESS,
                    payload: response,
                });

                if (callback) callback(response);
            })
            .catch((error) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_FAILURE,
                    payload: error,
                });
            });
    };

export const getProjects =
    ({ params, initLoad }) =>
    (dispatch, getState) => {
        const { stage, projectManagement } = getState();

        let finalParams = { ...params };

        dispatch({ type: PROJECT_MANAGEMENT_PENDING });
        dispatch(updateParams(params));

        if (initLoad) {
            finalParams = {
                orderField: projectManagement.params.orderField,
                orderKey: projectManagement.params.orderKey,
                limit: projectManagement.params.limit,
                offset: 0,
            };
        }

        return getProjectsAPI(stage.id, stage.endpoint, finalParams)
            .then((response) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_GET_PROJECTS_SUCCESS,
                    payload: response,
                });

                response.data.results.forEach((p) => {
                    if (p.status === "READY" || p.status === "PREPARING") {
                        startPolling(p.id, dispatch, getState);
                    }
                });
            })
            .catch((error) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_FAILURE,
                    payload: error,
                });
            });
    };

export const getProject = (id) => (dispatch, getState) => {
    const { stage, project } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return getProjectAPI(stage.id, stage.endpoint, project.id, id)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_GET_PROJECT_SUCCESS,
                payload: response,
            });

            if (response.data.status === "READY" || response.data.status === "PREPARING") {
                startPolling(id, dispatch, getState);
            }
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

export const updateProject = (id, data) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });
    return updateProjectAPI(stage.id, stage.endpoint, id, data)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UPDATE_PROJECT_SUCCESS,
                payload: response,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};
export const getProjectUsers = (id, params, showAll) => (dispatch, getState) => {
    const { stage, project } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_USERS_PENDING });

    return getProjectUsersAPI(stage.id, stage.endpoint, project.id, id, params, showAll)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_GET_PROJECT_USERS_SUCCESS,
                payload: response,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE,
                payload: error,
            });
        });
};

export const getProjectUsersV2 =
    ({ id, params, showAll, initLoad }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        let finalParams = { ...params };

        dispatch({ type: PROJECT_MANAGEMENT_PROJECT_USERS_PENDING });
        dispatch(updateUserParams(params));

        if (initLoad) {
            finalParams = { limit: getState().projectManagement.users?.params.limit };
        } else {
            finalParams.nextToken = params?.offset > 0 ? params.tokenPaginationInfo[params.offset - 1] : undefined;
        }

        return getProjectUsersV2API(stage.id, stage.endpoint, project.id, id, finalParams, showAll)
            .then((response) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_GET_PROJECT_USERS_SUCCESS,
                    payload: response,
                });
                return response?.data;
            })
            .catch((error) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE,
                    payload: error,
                });
            });
    };

export const getProjectAssignableUsersV2 = (id, params, isInit) => (dispatch, getState) => {
    const { stage, project } = getState();

    let _params = params ?? getState().projectManagement.assignableUsers.params;
    if (isInit) _params.nextToken = null;
    else _params.nextToken = getState().projectManagement.assignableUsers.nextToken;
    dispatch(updateAssignableUserParams(_params));

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_PENDING, payload: { isInit } });
    return getProjectUsersV2API(stage.id, stage.endpoint, project.id, id, _params, true)
        .then((response) => {
            let results = response.data.results;
            if (!isInit) results = [...getState().projectManagement.assignableUsers.results, ...response.data.results];

            dispatch({
                type: PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_USERS_SUCCESS,
                payload: { ...response, data: { ...response.data, results } },
            });
            return response?.data;
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_USERS_FAILURE,
                payload: error,
            });
        });
};

export const getProjectTeams = (id, params, showAll) => (dispatch, getState) => {
    const { stage, project } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING });

    return getProjectTeamsAPI(stage.id, stage.endpoint, project.id, id, params, showAll)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_GET_PROJECT_TEAMS_SUCCESS,
                payload: response,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE,
                payload: error,
            });
        });
};

export const getProjectTeamsV2 =
    ({ id, params, showAll, initLoad }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        let finalParams = { ...params };

        dispatch({ type: PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING });
        dispatch(updateTeamParams(params));

        if (initLoad) {
            finalParams = { limit: getState().projectManagement.teams?.params.limit };
        } else {
            finalParams.nextToken = params?.offset > 0 ? params.tokenPaginationInfo[params.offset - 1] : undefined;
        }

        return getProjectTeamsV2API(stage.id, stage.endpoint, project.id, id, finalParams, showAll)
            .then((response) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_GET_PROJECT_TEAMS_SUCCESS,
                    payload: response,
                });
                return response?.data;
            })
            .catch((error) => {
                dispatch({
                    type: PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE,
                    payload: error,
                });
            });
    };

export const getProjectAssignableTeamsV2 = (id, params, isInit) => (dispatch, getState) => {
    const { stage, project } = getState();

    let _params = params ?? getState().projectManagement.assignableTeams.params;
    if (isInit) _params.nextToken = null;
    else _params.nextToken = getState().projectManagement.assignableTeams.nextToken;
    dispatch(updateAssignableTeamParams(_params));

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_PENDING, payload: { isInit } });
    return getProjectTeamsV2API(stage.id, stage.endpoint, project.id, id, _params, true)
        .then((response) => {
            let results = response.data.results;
            if (!isInit) results = [...getState().projectManagement.assignableTeams.results, ...response.data.results];

            dispatch({
                type: PROJECT_MANAGEMENT_GET_PROJECT_ASSIGNABLE_TEAMS_SUCCESS,
                payload: { ...response, data: { ...response.data, results } },
            });
            return response?.data;
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_ASSIGNABLE_TEAMS_FAILURE,
                payload: error,
            });
        });
};

export const deleteProject = (id) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    return deleteProjectAPI(stage.id, stage.endpoint, id)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_DELETE_PROJECT_SUCCESS,
                payload: response,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_FAILURE,
                payload: error,
            });
        });
};

// 단일 페이지 데이터 조회
const fetchProjectPage = async (stage, params, offset) => {
    const requestParams = params ?? {
        offset,
        limit: 1000,
        scope: "all",
        isIntegratedSearchable: true,
    };

    return await getProjectsAPI(stage.id, stage.endpoint, requestParams);
};

// 모든 프로젝트 데이터 수집
const collectAllProjects = async (stage, params) => {
    let offset = 0;
    let allData = [];
    let totalCount = 0;

    do {
        const response = await fetchProjectPage(stage, params, offset);
        offset += 1000;
        allData.push(...response.data.results);
        totalCount = response.data.totalCount;
    } while (offset < totalCount);

    return allData;
};

// 메인 함수
export const getAllProjects = (params) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PENDING });

    try {
        const allProjects = await collectAllProjects(stage, params);

        dispatch({
            type: PROJECT_MANAGEMENT_GET_ALL_PROJECTS_SUCCESS,
            payload: { results: allProjects },
        });

        return { results: allProjects };
    } catch (error) {
        dispatch({
            type: PROJECT_MANAGEMENT_GET_ALL_PROJECTS_FAILURE,
            payload: error,
        });

        throw error;
    }
};

export const updateProjectUser = (projectId, userId, body) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_USERS_PENDING });
    return patchProjectUserAPI(stage.id, stage.endpoint, projectId, userId, body)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UPDATE_USER_SUCCESS,
                payload: {
                    ...body,
                    id: userId,
                },
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_USERS_FAILURE,
                payload: error,
            });
        });
};

export const updateProjectTeam = (projectId, teamId, body) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_PROJECT_TEAMS_PENDING });
    return patchProjectTeamAPI(stage.id, stage.endpoint, projectId, teamId, body)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_UPDATE_TEAM_SUCCESS,
                payload: {
                    ...body,
                    id: teamId,
                },
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_PROJECT_TEAMS_FAILURE,
                payload: error,
            });
        });
};

export const getSupportedRegions = (params) => (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: PROJECT_MANAGEMENT_SUPPORTED_REGIONS_PENDING });
    return getSupportedRegionsAPI(stage.id, stage.endpoint)
        .then((response) => {
            dispatch({
                type: PROJECT_MANAGEMENT_SUPPORTED_REGIONS_SUCCESS,
                payload: response,
            });
        })
        .catch((error) => {
            dispatch({
                type: PROJECT_MANAGEMENT_SUPPORTED_REGIONS_FAILURE,
                payload: error,
            });
        });
};
